<template>
  <nav class="navbar">
    <div class="navbar-container">
      <div class="logo-wrapper">
        <Logo />
      </div>

      <!-- Botón hamburguesa (solo visible en pantallas pequeñas) -->
      <button class="hamburger" @click="toggleMenu" aria-label="Menú">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </button>

      <div class="menu-wrapper" :class="{ 'menu-open': menuOpen }">
        <!-- Botón de cierre "X" (solo visible cuando el menú está abierto y en pantallas pequeñas) -->
        <button
          v-if="menuOpen"
          class="close-menu"
          type="button"
          aria-label="Cerrar menú"
          @click.prevent="closeMenu"
          @keydown.enter.prevent="closeMenu"
          @keydown.space.prevent="closeMenu"
        >
          &times;
        </button>

        <ul class="navbar-list">
          <li>
            <router-link to="/" exact @click="closeMenu">Inicio</router-link>
          </li>
          <li>
            <router-link to="/productos" @click="closeMenu"
              >Productos</router-link
            >
          </li>
          <li>
            <router-link to="/servicios" @click="closeMenu"
              >Servicios</router-link
            >
          </li>
          <li>
            <router-link to="/nosotros" @click="closeMenu"
              >Nosotros</router-link
            >
          </li>
          <li>
            <router-link to="/contactenos" @click="closeMenu"
              >Contáctenos</router-link
            >
          </li>

          <!-- Submenú PQR -->
          <li
            class="has-submenu"
            :class="{ open: showPqrSubmenu }"
            @mouseenter="showPqrSubmenu = true"
            @mouseleave="showPqrSubmenu = false"
          >
            <button
              class="submenu-toggle"
              @click.prevent="togglePqrSubmenu"
              :aria-expanded="showPqrSubmenu.toString()"
            >
              PQRSF
              <span class="arrow" :class="{ open: showPqrSubmenu }">▼</span>
            </button>
            <ul class="submenu">
              <li>
                <router-link to="/PQR-Servicios" @click="closeMenu"
                  >Servicios</router-link
                >
              </li>
              <li>
                <router-link to="/PQR-Productos" @click="closeMenu"
                  >Productos</router-link
                >
              </li>
              <li>
                <router-link
                  to="/PQR-Politica-de-Tratamiento-y-Proteccion-de-Datos"
                  @click="closeMenu"
                  >Política de Datos</router-link
                >
              </li>
            </ul>
          </li>

          <!-- Submenú de idiomas -->
          <!-- <li
            class="has-submenu"
            :class="{ open: showLangSubmenu }"
            @mouseenter="showLangSubmenu = true"
            @mouseleave="showLangSubmenu = false"
          >
            <button
              class="submenu-toggle main-lang-button"
              @click.prevent="toggleLangSubmenu"
              :aria-expanded="showLangSubmenu.toString()"
            >
              <img
                :src="currentLang === 'es' ? EspanaFlag : UsaFlag"
                alt="Idioma"
                class="lang-flag"
              />
              <span class="lang-initials">{{ currentLang.toUpperCase() }}</span>
              <span class="arrow" :class="{ open: showLangSubmenu }">▼</span>
            </button>

            <ul class="submenu language-submenu">
              <li>
                <button @click="changeLanguage('es')" class="flag-button">
                  <img :src="EspanaFlag" alt="Español" class="lang-flag" />
                  <span class="lang-initials">ES</span>
                </button>
              </li>
              <li>
                <button @click="changeLanguage('en')" class="flag-button">
                  <img :src="UsaFlag" alt="English" class="lang-flag" />
                  <span class="lang-initials">EN</span>
                </button>
              </li>
            </ul>
          </li> -->
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import Logo from "./Logo.vue";
import EspanaFlag from "@/assets/inicio/espana.webp";
import UsaFlag from "@/assets/inicio/estados-unidos.webp";

export default {
  components: {
    Logo,
  },
  data() {
    return {
      menuOpen: false, // Estado del menú hamburguesa
      showPqrSubmenu: false,
      showLangSubmenu: false,
      EspanaFlag,
      UsaFlag,
      currentLang: "es",
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
      this.showPqrSubmenu = false;
      this.showLangSubmenu = false;
      this.$emit("start-loading");
    },

    togglePqrSubmenu() {
      this.showPqrSubmenu = !this.showPqrSubmenu;
    },
    toggleLangSubmenu() {
      this.showLangSubmenu = !this.showLangSubmenu;
    },
    changeLanguage(lang) {
      console.log("Idioma cambiado a:", lang);
      this.currentLang = lang;
      this.$i18n.locale = lang;
      this.showLangSubmenu = false;
    },
  },
};
</script>

<style scoped>
/* Navbar base */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 8px rgb(0 0 0 / 0.1);
  z-index: 1000;
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo */
.logo-wrapper {
  flex-shrink: 0;
  margin-left: 20px; /* Ajustado para que quede bien a la izquierda */
}

/* Menú principal */
.menu-wrapper {
  flex-grow: 1;
  display: flex;
  justify-content: center;
}

.navbar-list {
  display: flex;
  gap: 24px;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
  flex-grow: 0;
}

.navbar-list li {
  position: relative;
}

/* Links y botones */
.navbar-list a,
.submenu-toggle {
  text-decoration: none;
  color: #333;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 12px;
  display: inline-block;
  user-select: none;
  transition: color 0.3s ease;
  border: none;
  background: none;
  font-family: inherit;
}

/* Resaltar el enlace activo con verde y línea debajo */
.router-link-active,
.router-link-exact-active {
  color: #2a9c44 !important;
  border-bottom: 2px solid #2a9c44 !important;
}
.navbar-list a {
  transition: color 0.3s ease, border-bottom 0.3s ease;
}

.navbar-list a:hover,
.submenu-toggle:hover {
  color: #2a9c44; /* verde para hover */
}

/* Submenu */
.has-submenu {
  cursor: pointer;
}

.submenu {
  text-align: left;
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  box-shadow: 0 4px 12px rgb(0 0 0 / 0.1);
  border-radius: 6px;
  padding: 10px 0;
  min-width: 220px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
  z-index: 10;
  list-style: none;
}

.has-submenu.open .submenu,
.has-submenu:hover .submenu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
}

/* Submenu items */
.submenu li a {
  display: block;
  padding: 8px 20px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.submenu li a:hover {
  background-color: #e6f4ea;
  color: #2a9c44;
  border-radius: 4px;
}

/* Flecha */
.arrow {
  font-size: 10px;
  margin-left: 6px;
  transition: transform 0.3s ease;
  display: inline-block;
  user-select: none;
}

.arrow.open {
  transform: rotate(180deg);
}

/* Submenú de idiomas (banderas en lista) */
.language-submenu {
  display: flex;
  flex-direction: column; /* Por defecto, columna */
  padding: 8px 12px;
  gap: 12px;
  min-width: auto;
  background: white;
}

/* Botones de las banderas en el submenú */
.flag-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: none;
  border: none;
  transition: background-color 0.3s ease;
}

.flag-button:hover {
  background-color: transparent;
  box-shadow: none;
}

/* Banderas */
.lang-flag {
  width: 24px;
  height: 16px;
  object-fit: cover;
  display: block;
  transition: transform 0.2s ease;
}

.lang-flag:hover {
  transform: scale(1.1);
}

.lang-initials {
  font-weight: 700;
  font-size: 14px;
  color: #333;
  user-select: none;
}

/* Botón principal de idioma */
.main-lang-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
}

.flag-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  transition: background-color 0.3s ease;
}

.flag-button:hover {
  background-color: #99e0aa;
  border-radius: 5px;
}

/* Estilos base para el botón hamburguesa */
.hamburger {
  display: none; /* Oculto en pantallas grandes */
  flex-direction: column;
  gap: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  width: 40px;
  height: 30px;
  justify-content: center;

  /* Posición a la derecha */

  margin-right: 20px;
}

.hamburger .bar {
  width: 30px;
  height: 3px;
  background-color: #2a9c44;
  border-radius: 5px;
}

/* Menú lateral */
.menu-wrapper {
  display: flex;
  justify-content: center;
}

.navbar-list {
  display: flex;
  gap: 24px;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
}

.navbar-list li {
  position: relative;
}

/* Menú lateral - cuando se abre */
.menu-wrapper.menu-open .navbar-list {
  right: 0;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
  padding: 20px 0;
}
/* Estilos botón cerrar menú */
.close-menu {
  position: fixed;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 2rem;
  font-weight: bold;
  cursor: pointer;
  color: #2a9c44;
  z-index: 1100; /* por encima del menú */
  display: none;
}

/* Mostrar botón cerrar solo en pantallas pequeñas y si el menú está abierto */
.menu-wrapper.menu-open .close-menu {
  display: block;
}

/* Opcional: animar cambio visual del botón hamburguesa cuando está abierto */
.hamburger .bar {
  transition: all 0.3s ease;
}

.hamburger .bar-open:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger .bar-open:nth-child(2) {
  opacity: 0;
}

.hamburger .bar-open:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* Responsive para tablets */
@media (max-width: 1024px) {
  .navbar-list {
    display: block;
    position: fixed;
    top: 0;
    right: -250px;
    width: 250px;
    height: 100vh;
    background: #fff;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    transition: right 0.3s ease;
    padding-top: 60px;
  }

  .navbar-list li {
    padding: 10px 20px;
  }

  .menu-wrapper.menu-open .navbar-list {
    right: 0;
  }

  .hamburger {
    display: flex;
    margin-left: 70%;
  }
}

/* Responsive para móviles */
@media (max-width: 768px) {
  .navbar-list {
    display: block;
    position: fixed;
    top: 0;
    right: -250px;
    width: 250px;
    height: 100vh;
    background: #fff;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    transition: right 0.3s ease;
    padding-top: 60px;
  }

  .navbar-list li {
    padding: 10px 20px;
  }

  .menu-wrapper.menu-open .navbar-list {
    right: 0;
  }

  .hamburger {
    display: flex;
    margin-left: 30%;
  }
}
</style>
